import Component from './component';

export interface Props extends ParentProps {
}

export interface IndexStructure {
    [key: number]: IndexLevel;
}

export interface IndexLevel {
    key: string;
    level: number;
    order: number;
    text: string;
    elements: IndexStructure;
}

export interface ParentProps {
    indexStructure: IndexStructure;
}

Component.defaultProps = {};
export default Component;
